import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["spinner"]

  addToCart({ detail: { content } }) {
    this.dispatch("addToCart", { detail: { content: { productId: content.productId, year: content.year } } })
    this.spinnerTarget.classList.remove('d-none');

    setTimeout(()=>{
      this.spinnerTarget.classList.add('d-none');
    }, 1000);
  };
}
